var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.err)?_vm._t("error",function(){return [_vm._v("Something went wrong")]},{"err":_vm.err,"vm":_vm.vm,"info":_vm.info}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }